import { /*EventEmitter,*/ TypedEventEmitter, TypedEventListener } from "./events";

export interface ControlEvent extends CustomEvent { }

export default interface Control {
    // setValue(value:any):void
    // getValue():any
    // setFocus():void
    // setVisibility(visible:boolean):void
    // setReadOnly(readonly: boolean):void
    // setEnable(enabled: boolean):void
    setProperty(name: string, value: any): void
    getProperty(name: string): any
    dipose(): void
}

export default interface Control {
    setProperty<K extends keyof ControlDefaultPropertiesMap>(name: K, value: ControlDefaultPropertiesMap[K]): void
    getProperty<K extends keyof ControlDefaultPropertiesMap>(name: K): ControlDefaultPropertiesMap[K]
}

interface ControlDefaultPropertiesMap {
    "enabled": boolean,
    "visible": boolean,
    "readonly": boolean
}

export abstract class ControlBase implements EventTarget, Control {

    protected readonly rootElement: HTMLElement
    private readonly propertyStorer: Record<string, any> = {}
    private _suspendEventsCounter: number = 0

    constructor() {
        this.rootElement = this.createRootElement()
    }

    protected abstract createRootElement(): HTMLElement;

    abstract render(parent: HTMLElement): void

    setProperty(name: string, value: any): void {
        this.throwIfPropertyNotExists(name)
        if (this.propertyStorer[name] != value && this.onPropertyChanging(name, value)) {
            this.propertyStorer[name] = value
            this.onPropertyChanged(name)
        }
    }

    getProperty(name: string): any {
        this.throwIfPropertyNotExists(name)
        return this.propertyStorer[name]
    }

    addEventListener(type: string, listener: EventListener | EventListenerObject | null, options?: boolean | AddEventListenerOptions): void {
        (this.rootElement as EventTarget).addEventListener(type, listener, options)
    }
    dispatchEvent(event: Event): boolean {
        return (this.rootElement as EventTarget).dispatchEvent(event)
    }

    removeEventListener(type: string, callback: EventListener | EventListenerObject | null, options?: boolean | EventListenerOptions): void {
        (this.rootElement as EventTarget).removeEventListener(type, callback, options)
    }

    abstract dipose(): void

    private throwIfPropertyNotExists(propertyName: string): void | never {
        if (!this.propertyStorer.hasOwnProperty(propertyName))
            throw new Error(`Invalid property "${propertyName}".`)
    }

    protected defineProperties(descriptor: PropertyDescriptorMap) {
        Object.defineProperties(this.propertyStorer, descriptor)
    }

    protected onPropertyChanged(property: string) { }

    protected onPropertyChanging(property: string, newValue: any): boolean {
        return true;
    }

    protected isEventsSuspended() {
        return this._suspendEventsCounter > 0;
    }

    suspendEvents() {
        this._suspendEventsCounter++;
    }

    resumeEvents() {
        if (this._suspendEventsCounter > 0) {
            this._suspendEventsCounter--;
        }
    }
}


// interface EventHandler {
//     events: EventEmitter
//     addEventListener(type: string, listener: EventListener): void
//     removeEventListener(type: string, listener: EventListener): void
// }


//type ListenerMapValue = { [type: string]: (EventListener | EventListenerObject)[] }

